<template>
  <nav
    :class="['fixed top-0 left-0 right-0 z-50 transition-all duration-300', scrolled ? 'glass-dark shadow-lg' : 'glass']">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex items-center justify-between h-20">
        <!-- Logo -->
        <div class="flex-shrink-0">
          <h1 class="text-2xl sm:text-3xl font-display font-bold text-gold-gradient cursor-pointer">
            شركة النضار
          </h1>
        </div>

        <!-- Desktop Navigation -->
        <div class="hidden md:flex items-center space-x-8 space-x-reverse">
          <a v-for="link in navLinks" :key="link.id" :href="link.href"
            class="text-gray-300 hover:text-gold-500 transition-smooth font-medium text-sm lg:text-base">
            {{ link.label }}
          </a>
        </div>

        <!-- Mobile Menu Button -->
        <button @click="toggleMobileMenu" class="md:hidden text-gold-500 hover:text-gold-400 transition-smooth p-2"
          aria-label="Toggle menu">
          <Menu v-if="!mobileMenuOpen" :size="28" />
          <X v-else :size="28" />
        </button>
      </div>
    </div>

    <!-- Mobile Navigation -->
    <Transition name="slide">
      <div v-if="mobileMenuOpen" class="md:hidden glass-dark border-t border-gold-500/20">
        <div class="px-4 py-6 space-y-4">
          <a v-for="link in navLinks" :key="link.id" :href="link.href" @click="closeMobileMenu"
            class="block text-gray-300 hover:text-gold-500 transition-smooth font-medium text-lg py-2">
            {{ link.label }}
          </a>
        </div>
      </div>
    </Transition>
  </nav>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { Menu, X } from 'lucide-vue-next'

// Navigation links
const navLinks = [
  { id: 'home', label: 'الرئيسية', href: '#home' },
  { id: 'about', label: 'من نحن', href: '#about' },
  { id: 'products', label: 'المنتجات', href: '#products' },
  { id: 'contact', label: 'اتصل بنا', href: '#contact' }
]

// State
const scrolled = ref(false)
const mobileMenuOpen = ref(false)

/**
 * Handle scroll event to change navbar appearance
 */
const handleScroll = () => {
  scrolled.value = window.scrollY > 50
}

/**
 * Toggle mobile menu
 */
const toggleMobileMenu = () => {
  mobileMenuOpen.value = !mobileMenuOpen.value
}

/**
 * Close mobile menu
 */
const closeMobileMenu = () => {
  mobileMenuOpen.value = false
}

// Lifecycle hooks
onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<style scoped>
/* Slide transition for mobile menu */
.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease-out;
}

.slide-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}

.slide-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
